(function () {
  /* globals console */
  'use strict';

  angular.module('wsLrs.controllers').factory("Card", ['$q', 'Api', '$http', 'Resource', 'Utils', function ($q, Api, $http, Resource, Utils) {
    var baseResource = new Resource("/cards", true, true),
      tenantBoundResource = new Resource("/cards", false, true);
    var resource = _.extend(baseResource, {
      get: _.bind(tenantBoundResource.get, tenantBoundResource),
      getAll: function getAll(cfg) {
        cfg = cfg || {};
        cfg.maxLimit = cfg.maxLimit || 50000;
        return tenantBoundResource.getAll(cfg);
      },
      multiGet: _.bind(tenantBoundResource.multiGet, tenantBoundResource),
      list: _.bind(tenantBoundResource.list, tenantBoundResource),
      find: _.bind(tenantBoundResource.find, tenantBoundResource),
      getPage: function getPage(limit, offset, includeMetadata) {
        var searchTerm = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '';
        var params = searchTerm.length > 0 ? {
          _limit: limit,
          _offset: offset,
          includeMetadata: includeMetadata,
          in_title: searchTerm
        } : {
          _limit: limit,
          _offset: offset,
          includeMetadata: includeMetadata
        };
        return $http({
          method: 'GET',
          url: Api.url('/cards'),
          params: params
        });
      },
      adopt: function adopt(cardId) {
        var url = Api.url("/cards/" + cardId + "/adopt", true);
        return $http.post(url).then(function success(response) {
          // Created new copy
          return {
            foundExisting: false,
            cardId: Utils.getIdFromCreatedResponse(response)
          };
        }, function error(response) {
          // Found an existing copy
          if (response.status === 409) {
            return {
              foundExisting: true,
              cardId: Utils.getIdFromCreatedResponse(response)
            };

            // Unexpected error
          } else {
            return $q.reject(response);
          }
        });
      },
      groupWith: function groupWith(sourceId, targetId, userId) {
        var url = Api.url("/cards/" + sourceId + "/group-with/" + targetId, true),
          params = {
            userId: userId
          };
        return $http.post(Utils.appendParams(url, params)).then(function success(response) {
          return response.data;
        });
      },
      moveToGroup: function moveToGroup(cardId, cardGroupId, sourceGroupId) {
        var url = Utils.appendParams(Api.url("/cards/" + cardId + "/move-to-group/" + cardGroupId, true), {
          sourceGroupId: sourceGroupId
        });
        return $http.post(url).then(function success(response) {
          return response.data;
        });
      }
    });
    return resource;
  }]);
})();
(function () {
  'use strict';

  angular.module('wsLrs.cards').
  /**
   * Service for loading Watershed cards
   **/
  factory('CardLoader', ['$rootScope', 'Api', 'CardRegistry', '$templateRequest', 'ShareUtils', 'wsEventNames', '$route', '$http', 'MeasureRegistry', '$q', function ($rootScope, Api, CardRegistry, $templateRequest, ShareUtils, wsEventNames, $route, $http, MeasureRegistry, $q) {
    return {
      resourceCache: {},
      loadCards: function loadCards() {
        $rootScope.$broadcast(wsEventNames.cardLoader.loadCards);
        var self = this;
        //First thing, test for a share so that we can use the right path.
        //If there isn't a share in the context, it'll return immediately.
        return ShareUtils.getShare().then(function (share) {
          var cardsUrl = Api.url("/cards/" + $route.current.params.cardId, true, true);
          if (typeof self.resourceCache[cardsUrl] === "undefined") {
            // Loading categories here not supported in share context
            var loadCategories = !share;
            var promise = MeasureRegistry.prepareMeasures({
              _includeCategories: loadCategories
            });
            if ($route.current.params.cardId && $route.current.params.cardId !== "preview") {
              promise = promise.then(function () {
                return $http.get(cardsUrl);
              }).then(function (r) {
                var card = r.data;
                MeasureRegistry.setMeasuresOnCard(card);
                CardRegistry.add(card);
                return card;
              }).catch(function (e) {
                console.log(e);
                return $q.reject(e);
              });
            }
            self.resourceCache[cardsUrl] = promise;
          }
          return self.resourceCache[cardsUrl];
        });
      },
      getTemplateHtml: function getTemplateHtml(template) {
        return $templateRequest(template.assetLocation);
      },
      clearCache: function clearCache() {
        this.resourceCache = {};
      }
    };
  }]).factory('CardServices', ['$q', 'Api', "$http", 'CardRegistry', 'CardLoader', 'CardUtils', 'DefaultCardGroups', 'Logger', 'Utils', function ($q, Api, $http, CardRegistry, CardLoader, CardUtils, DefaultCardGroups, Logger, Utils) {
    return {
      saveConfiguration: function saveConfiguration(card, createCardSuccess, updateCardSuccess, usedAdvancedConfig) {
        var savePromise = null;

        // If the persisted field has been set to false, this is a new card,
        // so we'll have to post it fresh
        if (card.persisted === false) {
          savePromise = $http.post(Api.url("/cards" + (usedAdvancedConfig ? "?advanced=true" : ""), true), card).then(function (response) {
            card.persisted = true;
            card.id = parseInt(Utils.getIdFromCreatedResponse(response), 10);
            card.created = new Date().toISOString();
            if (!card.hidden && card.template.hasDetailPage) {
              card.detailsUrl = CardUtils.getCardUrl(card);
            }
            createCardSuccess(card, response);
          });

          // Otherwise, this is an existing card, just save the config
        } else {
          savePromise = $http.put(Api.url("/cards/" + card.id + (usedAdvancedConfig ? "?advanced=true" : ""), true), card).then(function (response) {
            updateCardSuccess(card, response);
          });
        }
        return savePromise.then(function () {
          CardRegistry.add(card);
          CardLoader.clearCache();
          DefaultCardGroups.clearCache();
        }, function (response) {
          Logger.error("Card saving failed with response status " + response.status);
          return $q.reject("There was an error saving this report.");
        });
      }
    };
  }]).
  /**
   * Service for remembering and retrieving card objects
   */
  factory("CardRegistry", ['$templateRequest', '$q', 'Card', 'MeasureRegistry', '$location', function ($templateRequest, $q, Card, MeasureRegistry, $location) {
    var registry = {
      cards: {},
      _templateFetches: [],
      clear: function clear() {
        registry.cards = {};
      },
      add: function add(card) {
        registry.cards[card.id] = card;
        registry._templateFetches.push($templateRequest(card.template.assetLocation).then(function (template) {
          card.template.html = template;
        }, function () {
          // no op
        }));
      },
      get: function get(cardId) {
        return registry.cards[cardId] || {};
      },
      /**
       * Fetch the current card from the registry. This expects that an ID can
       * be found in the URL. If there is no card to be found, and it is not a
       * preview request, simply request an empty object.
       */
      getCurrentCard: function getCurrentCard() {
        var cardId = $location.path().match(/\d+/);
        var isPreview = !cardId && $location.path().includes('preview');
        if (isPreview) {
          cardId = 'preview';
        }
        return registry.cards[cardId] || {};
      },
      getCardGroupCards: function getCardGroupCards(cardGroupIds) {
        var cardGroupCards = _.values(registry.cards).filter(function (c) {
          return c.template.name === 'card-group';
        });
        if (cardGroupIds) {
          cardGroupCards = cardGroupCards.filter(function (c) {
            return cardGroupIds.indexOf(c.configuration.cardGroupId) > -1;
          });
        }
        return cardGroupCards;
      },
      multiGet: function multiGet(cardIds) {
        cardIds = cardIds || [];

        //only get the cards that are not already in the registry
        return MeasureRegistry.prepareMeasures({
          _includeCategories: true
        }).then(function () {
          return Card.multiGet(_.filter(cardIds, function (c) {
            return !registry.has(c);
          }));
        }).then(function (r) {
          var cards = r.results;

          //add all the new cards to the registry
          _.chain(cards).filter(function (c) {
            return !registry.has(c.id);
          }).each(function (card) {
            MeasureRegistry.setMeasuresOnCard(card);
            registry.add(card);
          });

          // Ensure we have all the templates and return the cards
          return $q.all(registry._templateFetches).then(function () {
            return _.chain(cardIds).filter(function (c) {
              return registry.has(c);
            }).map(function (c) {
              return registry.get(c);
            }).value();
          });
        }).catch(function (e) {
          console.log(e);
          return $q.reject(e);
        });
      },
      has: function has(cardId) {
        return registry.cards.hasOwnProperty(cardId);
      }
    };
    return registry;
  }]).
  /**
   * A registry of card icons
   */
  factory("CardIconMap", [function () {
    function computeKey(templateName) {
      return templateName;
    }
    return {
      _iconMap: {},
      register: function register(iconMap) {
        var self = this;
        _.each(iconMap, function (value, templateName) {
          self._iconMap[computeKey(templateName)] = value;
        });
      },
      getIcon: function getIcon(templateName) {
        return this._iconMap[computeKey(templateName)];
      }
    };
  }]).
  /**
   * A service for utilities that can be shared by cards
   */
  factory("CardUtils", ["CardRegistry", "$location", 'OrganizationSettings', function (CardRegistry, $location, OrganizationSettings) {
    return {
      setNavElements: function setNavElements($scope, obj, cardId) {
        //do not set headline if in preview mode
        if (cardId !== null && cardId === "preview") {
          $scope.$emit("headline:change", "hide");
          return;
        }
        var headline = null,
          card = null;
        if (typeof obj === "string" && !obj.match(/^\d+$/)) {
          // Explicit string
          headline = obj;
        } else if (!isNaN(parseInt(obj))) {
          // Card ID
          card = CardRegistry.get(obj);
          if (card) {
            headline = card.title;
          }
        }
        if (headline) {
          $scope.$emit("headline:change", headline);
        }
      },
      getCardUrl: function getCardUrl(card, hidePrefix, view) {
        if (!card) {
          return;
        }
        var url = hidePrefix ? "" : "#/";
        if (card.template) {
          var tName = card.template.name,
            cName;

          // If this template name has a hash, it's an old
          // custom template that has been migrated
          if (tName.indexOf("#") >= 0) {
            var templateNameParts = tName.split("#");
            cName = templateNameParts[0];
            tName = templateNameParts[1];
          }
          var result = url;
          if (!!cName) {
            result += cName + "/";
          }
          result += tName + "/" + card.id;
          if (view && view === 'card') {
            return result + "/top";
          } else {
            // normal/detail view
            if (card.configuration.cardGroupId && card.cardGroupIds) {
              //special card group url logic
              result += "?parentGroupId=" + card.cardGroupIds[0] + "&parentCardId=" + card.configuration.cardGroupId;
            }
            if (_.any(_.values(card.configuration.quickFilters)) || _.any(_.values(OrganizationSettings.hasFeature("defaultQuickFilters"))) || card.configuration.cardGroupId && $location.url().indexOf("filter=") > -1) {
              //preserve quickfilter when links are followed
              var filter = $location.url().replace($location.path(), "");
              if (result.indexOf('?') > -1 && filter.indexOf('?') > -1) {
                filter = filter.replace('?', '&');
              }
              return result + filter;
            }
            return result;
          }
        } else {
          return null;
        }
      }
    };
  }]);
})();
